import React from "react";
import { Layout, Space, theme, Button } from "antd";
import { useLogout } from "@refinedev/core";
import { CurrentUser } from "../current-user";

const { useToken } = theme;

export const Header: React.FC = () => {
  const { token } = useToken();
  const { mutate: logout } = useLogout();

  const headerStyles: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 24px",
    height: 64,
    position: "sticky",
    top: 0,
    zIndex: 9,
  };

  return (
    <Layout.Header style={headerStyles}>
      <div />
      <Space align="center" size="middle">
        <Button onClick={() => logout()} type="default">Выйти</Button>
        <CurrentUser />
      </Space>
    </Layout.Header>
  );
};

